import { MoonfallAnalytics } from '../analytics/posthog-init.js';
/**
 * The game's doors to the Moonfall Discord, one per place that shows one.
 *
 * Each place has its own permanent invite (never expires, no use limit),
 * created on the channel that place talks about, so the player lands where
 * the line pointed and Discord's own Invites page counts the joins each place
 * brought, with nothing recorded on our side. A place that brings nobody is
 * removed again (docs/analytics.md, "Discord doors").
 *
 * The site-wide invite (`discord.gg/5tAxsXJB4S`, #general) stays on the
 * landing page, the blog and the desktop block screen; reusing it here would
 * fold every in-game join into theirs.
 */
let DiscordLinks = {};

DiscordLinks = (function () {
    const INVITES = Object.freeze({
        // The Community sheet's row, from the account bar. Lands in #rules-and-info.
        community: 'https://discord.gg/r4nVgjK9DA',
        // Play with Friends, while a created room waits. Lands in #looking-for-players.
        room: 'https://discord.gg/MCUhG73Cf8',
        // Play with Friends, before a room exists, under the code field. Lands in
        // #looking-for-players too, on its own invite so its joins count apart.
        friends: 'https://discord.gg/xxRqwejN4c',
        // The feedback window's "Discord". Lands in #feedback.
        feedback: 'https://discord.gg/DxXRwW4VZF',
        // A card the player discovered first. Lands in #recipes.
        discovery: 'https://discord.gg/U6ERFn5vE9',
        // The Moon Exchange's "Share listing" sheet. Lands in #trades.
        trades: 'https://discord.gg/dt6n4we9m5',
    });

    function inviteFor(surface) {
        return Object.prototype.hasOwnProperty.call(INVITES, surface) ? INVITES[surface] || null : null;
    }

    /** Counts one press, for players who allowed analytics; the place, nothing else. */
    function noteOpened(surface) {
        if (!inviteFor(surface)) return;
        MoonfallAnalytics?.capture?.('discord_opened', { surface });
    }

    /**
     * A real link, so the browser opens Discord from the tap itself: a
     * `window.open` after any await is a blocked popup on phones.
     */
    function createLink(surface, text, className) {
        const href = inviteFor(surface);
        if (!href) return null;
        const link = document.createElement('a');
        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.dataset.discordSurface = surface;
        if (className) link.className = className;
        link.textContent = text;
        link.addEventListener('click', () => noteOpened(surface));
        return link;
    }

    return { INVITES, inviteFor, noteOpened, createLink };
})();

export { DiscordLinks };
